import clsx from 'clsx';
import { MockDataBar } from 'components/Mock/MockDataBar';

import styles from './ScoutingReportMock.module.scss';

interface ScoutingReportMockProps {
  className?: string;
}
export const ScoutingReportMock = ({ className }: ScoutingReportMockProps) => {
  return (
    <div className={clsx(styles.journal, className)}>
      {[...Array(10)].map((_, index) => {
        const height = index === 0 ? '1rem' : '0.75rem';
        const width =
          index === 0
            ? '40%'
            : index === 1
              ? '20%'
              : index === 9
                ? '35%'
                : '100%';

        return <MockDataBar height={height} key={index} width={width} />;
      })}
    </div>
  );
};
